export const preventAutoRevalidationConfig = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  dedupingInterval: process.env.NODE_ENV === 'test' ? 0 : 60000000, // Set to a large number
};
